import objectFitImages from 'object-fit-images';

// https://github.com/fregante/object-fit-images
objectFitImages();

/**
 * Indicate if the header should have fill color or if should be transparent on page load
 */
function pageHeaderDetection() {
    // find the first section
    const firstSection = document.getElementById('section-number-1');
    // check if it has background color or background image
    const hasBgColor = firstSection.classList.contains('section--bg-color');
    const hasBgImg = firstSection.classList.contains('section--bg-img');
    const hasPageHeader = firstSection.classList.contains('s-page-header');
    const hasPageHeaderSimple = firstSection.classList.contains('s-page-header-simple');

    // keep the site header transparent
    if (hasBgColor || hasBgImg || hasPageHeader || hasPageHeaderSimple) {
        return;
    }

    // make site header white
    /* TODO: replace .js-no-page-header class with something js-header-white or js-header-fill-color */
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('js-no-page-header');
}
pageHeaderDetection();

/**
 * Reduce padding of section with a background color
 * when a section before or after has also a background color
 *
 * TODO: only reduce padding if sections have the same background color
 */
$(window).on('load', function () {
    // immediately run this function
    (() => {
        /* get all section with background color */
        const bgColorSections = document.querySelectorAll('.section--bg-color');

        /* do something with each found section */
        bgColorSections.forEach(function (section) {
            const sectionBgColor = window.getComputedStyle(section).getPropertyValue('background-color'),
                prevSection = section.previousElementSibling,
                nextSection = section.nextElementSibling;

            let prevSectionBgColor = null,
                nextSectionBgColor = null;

            if (prevSection !== null) {
                prevSectionBgColor = window.getComputedStyle(prevSection).getPropertyValue('background-color');
            }

            if (nextSection !== null) {
                nextSectionBgColor = window.getComputedStyle(nextSection).getPropertyValue('background-color');
            }

            /* if the current section has the same background color as prev section,
            reduce its top padding */
            if (null !== prevSection && sectionBgColor === prevSectionBgColor) {
                /* console.log('a section with bg-color before'); */
                section.classList.add('section--top-p-small');
            }

            /* if the current section has the same background color as next section,
            reduce its bottom padding */
            if (null !== nextSection && sectionBgColor === nextSectionBgColor) {
                /* console.log('a section with bg-color after'); */
                section.classList.add('section--bottom-p-small');
            }
        });
    })();
});

let typewriters = document.querySelectorAll('.typewriter-container');

typewriters.forEach((typeWriterElement) => {
    let attr = typeWriterElement.getAttribute('data-textarray');
    let textArray = attr.split(',');

    function delWriter(text, i, cb) {
        if (i >= 0) {
            typeWriterElement.innerHTML = text.substring(0, i--);
            var rndBack = 10 + Math.random() * 50;
            setTimeout(function () {
                delWriter(text, i, cb);
            }, rndBack);
        } else if (typeof cb == 'function') {
            setTimeout(cb, 1000);
        }
    }

    function typeWriter(text, i, cb) {
        if (i < text.length + 1) {
            typeWriterElement.innerHTML = text.substring(0, i++);
            var rndTyping = 150 - Math.random() * 100;
            setTimeout(function () {
                typeWriter(text, i++, cb);
            }, rndTyping);
        } else if (i === text.length + 1) {
            setTimeout(function () {
                delWriter(text, i, cb);
            }, 1000);
        }
    }

    function StartWriter(i) {
        if (typeof textArray[i] == 'undefined') {
            setTimeout(function () {
                StartWriter(0);
            }, 1000);
        } else if (i < textArray[i].length + 1) {
            typeWriter(textArray[i], 0, function () {
                StartWriter(i + 1);
            });
        }
    }

    setTimeout(function () {
        StartWriter(0);
    }, 1000);
});

// Smooth scroll on anchor link click
// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('a.c-submenu__link[href^="#"]')
    .not('[href^="#popup-"]')
    .click(function (event) {
        // On-page links
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            // Figure out element to scroll to
            let target = $(this.hash),
                header = $('.site-header'),
                targetTopMargin = parseInt(target.css('margin-top'), 10) / 2, // half of top margin
                scrollLength = target.offset().top - header.outerHeight() - targetTopMargin;

            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({ scrollTop: scrollLength }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    let $target = $(target);
                    $target.focus();
                    if ($target.is(':focus')) {
                        // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    }
                });
            }
        }
    });

// Responsive Iframe, keep ratio
// var $all_oembed_videos = $('iframe[src*="youtube"], iframe[src*="vimeo"]');
// $all_oembed_videos.each(function () {
//     $(this).removeAttr('height').removeAttr('width').wrap('<div class="embed-container"></div>');
// });

// Take all the tel: and mailto: links from the content columns of the contact section and change them into copyable elements
$('.c-content a:not(.prevent-copy)').each(function () {
    let $this = $(this);

    if (($(window).width() > 576 && $this.attr('href').indexOf('mailto:') > -1) || ($(window).width() > 576 && $this.attr('href').indexOf('tel:') > -1) || ($(window).width() < 576 && $this.attr('href').indexOf('mailto:') > -1)) {
        $this.addClass('link-replace');
        let linkText = $this.text();
        $this.append('<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.0016 9.72758C11.0016 9.96871 10.9058 10.2 10.7353 10.3705C10.5648 10.541 10.3335 10.6368 10.0924 10.6368H4.18263C3.9415 10.6368 3.71024 10.541 3.53973 10.3705C3.36923 10.2 3.27344 9.96871 3.27344 9.72758V1.99946C3.27344 1.75833 3.36923 1.52707 3.53973 1.35657C3.71024 1.18606 3.9415 1.09027 4.18263 1.09027H8.27398L11.0016 3.81784V9.72758Z" stroke="black" stroke-width="0.979127" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.27352 12.9097H1.90919C1.66806 12.9097 1.4368 12.8139 1.2663 12.6434C1.09579 12.4729 1 12.2417 1 12.0005V3.81781" stroke="black" stroke-width="0.979127" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        $this.append('<span class="copied hide"><p>Copied!</p></span>');

        let copyMessage = $this.find('.copied');
        $this.on('click', function (e) {
            e.preventDefault();

            copyMessage.removeClass('hide');

            let helperInput = document.createElement('input');
            document.body.appendChild(helperInput);
            helperInput.value = linkText;
            helperInput.select();
            document.execCommand('copy');
            document.body.removeChild(helperInput);

            setTimeout(() => {
                copyMessage.addClass('hide');
            }, 2000);
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/routes/other/generic.js